import { reflect } from 'kaop';

var META_KEY = "#META";
var KEY_ORIGINAL_METHOD = "original-method";
var KEY_BEFORE_METHOD = "before-method";
var KEY_AFTER_METHOD = "after-method";
var KEY_BEFORE_INSTANCE = "before-instance";
var KEY_AFTER_INSTANCE = "after-instance";

var defineMetadata = function (target, key, prop) {
    if (!target[META_KEY])
        target[META_KEY] = {};
    target[META_KEY][key] = prop;
};
var getMetadata = function (target, key) {
    return target[META_KEY] && target[META_KEY][key];
};

function generateKey(scope, methodName) {
    return scope + "-" + methodName;
}
function wrapMethod(target, methodName, beforeKey, afterKey) {
    var keyOriginalMethod = generateKey(KEY_ORIGINAL_METHOD, methodName);
    return reflect.createProxyFn(target, methodName, (getMetadata(target, beforeKey) || []).concat([
        getMetadata(target, keyOriginalMethod)
    ], getMetadata(target, afterKey) || []));
}
function applyReflect(target, advices, methodName, keyJoinPoint, original) {
    var keyOriginalMethod = generateKey(KEY_ORIGINAL_METHOD, methodName);
    var adviceArr = getMetadata(target, keyJoinPoint) || [];
    adviceArr.push.apply(adviceArr, advices.map(reflect.advice));
    defineMetadata(target, keyJoinPoint, adviceArr);
    if (!getMetadata(target, keyOriginalMethod))
        defineMetadata(target, keyOriginalMethod, original);
    if (methodName === "constructor") {
        var keyBeforeInstance = generateKey(KEY_BEFORE_INSTANCE, methodName);
        var keyAfterInstance = generateKey(KEY_AFTER_INSTANCE, methodName);
        var result = wrapMethod(target, methodName, keyBeforeInstance, keyAfterInstance);
        result.prototype = target.prototype;
        return result;
    }
    else {
        var keyBeforeMethod = generateKey(KEY_BEFORE_METHOD, methodName);
        var keyAfterMethod = generateKey(KEY_AFTER_METHOD, methodName);
        return wrapMethod(target, methodName, keyBeforeMethod, keyAfterMethod);
    }
}
function beforeMethod() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName, descriptor) {
        var keyBeforeMethod = generateKey(KEY_BEFORE_METHOD, methodName);
        descriptor.value = applyReflect(target, advices, methodName, keyBeforeMethod, descriptor.value);
        return descriptor;
    };
}
function afterMethod() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName, descriptor) {
        var keyAfterMethod = generateKey(KEY_AFTER_METHOD, methodName);
        descriptor.value = applyReflect(target, advices, methodName, keyAfterMethod, descriptor.value);
        return descriptor;
    };
}
function beforeInstance() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName) {
        if (methodName === void 0) { methodName = "constructor"; }
        var keyBeforeInstance = generateKey(KEY_BEFORE_INSTANCE, methodName);
        target = applyReflect(target, advices, methodName, keyBeforeInstance, target);
        return target;
    };
}
function afterInstance() {
    var advices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        advices[_i] = arguments[_i];
    }
    return function (target, methodName) {
        if (methodName === void 0) { methodName = "constructor"; }
        var keyAfterInstance = generateKey(KEY_AFTER_INSTANCE, methodName);
        target = applyReflect(target, advices, methodName, keyAfterInstance, target);
        return target;
    };
}

var onException = function (advice) { return afterMethod(function (meta) { return meta.exception && advice(meta); }); };

function applyAspect(definition) {
    return function (target) {
        var ctor = definition["constructor"] instanceof Array ? definition["constructor"] : [];
        delete definition["constructor"];
        var _loop_1 = function (key) {
            definition[key].forEach(function (advice) {
                return Object.defineProperty(target.prototype, key, advice(target, key, Object.getOwnPropertyDescriptor(target.prototype, key)));
            });
        };
        for (var key in definition) {
            _loop_1(key);
        }
        ctor.forEach(function (advice) { return target = advice(target); });
        return target;
    };
}

export { afterMethod, beforeMethod, afterInstance, beforeInstance, onException, applyAspect };
